export class ContactsPresentationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getContactsPresentation() {
    return this.#http.get('/api/Contacts-Presentation');
  }

  async updateContactsPresentation(body) {
    return this.#http.put('/api/Contacts-Presentation', body);
  }
}
